import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import NodeMap2 from "./node-map2";

const MapItems = loader("../graphql/Map.graphql");

interface Props {
  nodes?: any[];
  panelId?: string;
  // startDate: number; // Date;
  // endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

const MapContainer = (props: Props) => {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const { /*nodes,*/ panelId } = props;
  const { data, error, loading } = useQuery(MapItems, {
    variables: { panel: panelId },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // console.log("Map Data");
  // console.log(data);

  return <NodeMap2 nodes={data.mapItems} />;
};

export default MapContainer;
